// R115 calendar hub — deep links INTO the Calendar from any page (Executive
// Summary drill-downs, Slack ?open=stay:<id>, ⌘K …). Importable WITHOUT
// importing the page (no App ↔ page import cycle):
//
//   import { openCalendar } from './calendar/link';          // from client/src/pages
//   openCalendar({ view: 'ops', date: '2026-10-20', listing_id: '271134', stay_id: '53044546', src: 'exec' });
//
// It writes the one-shot sessionStorage 'stc_focus' (v1, validated by
// lib/calendarCore parseFocus — a bad id / date / view refuses the whole link),
// dispatches the document event 'stc:focus' (App.navigate is a no-op when the
// Calendar is already open, so the page listens for it), then 'app:navigate'
// → 'stays'. The page consumes the key on its next render (or right away on
// the event): the view is TRANSIENT (never becomes the tab's remembered view),
// the window moves to contain the date, the row is outlined and the stay /
// turn / work order opens in the inspector.
import { FOCUS_EVENT, FOCUS_KEY, serializeFocus } from '../../../../lib/calendarCore.mjs';

export { FOCUS_EVENT, FOCUS_KEY };
export interface OpenCalendarOpts {
  view?: string; date?: string; listing_id?: string; stay_id?: string; turn_id?: string; wo_id?: string; src?: string;
}

/** Hand off to the Calendar. Returns false (and does nothing) when the link does not validate. */
export function openCalendar(o: OpenCalendarOpts): boolean {
  const s = serializeFocus(o);
  if (!s) return false;
  try { sessionStorage.setItem(FOCUS_KEY, s); } catch { return false; }
  try { document.dispatchEvent(new CustomEvent(FOCUS_EVENT, { detail: JSON.parse(s) })); } catch { /* no DOM events — the render still consumes the key */ }
  document.dispatchEvent(new CustomEvent('app:navigate', { detail: 'stays' }));
  return true;
}
